export enum DomStorage {
  ACTIVE_APPLICATION = 'active-application',
  ACTIVE_UNIT = 'active-unit',
  ACTIVE_UNIT_ID = 'active-unit-id',
  AUTH_TOKEN = 'auth-token',
  IGNORE_SM = 'ignore-sm',
  LANGUAGE = 'language',
  ONBOARDING_VARIANT = 'onboarding_variant',

  ORIGIN_URL_PATH = 'origin_url_path',
  ORIGIN_URL_QUERIES = 'origin_url_queries',
  USERCENTRICS_INTERACTION = 'uc_user_interaction',

  B2B_ACTIVE_COMPANY_ID = 'active_company',

  FEATURE_FLAGS_CACHE = 'featureFlags:v1',

  APPLICATION_ROUTE_UNLOCKED = 'application-route-unlocked',
}
